export default __webpack_public_path__ + "src/images/packages/qambathi-mountain-lodge/d0b8586521b1b45996bdc09247ba707d-4.jpg";